// Header displays the header image and the page's title
//    - @author Manuel Ondina <manuel-rafael.ondina-aja@hp.com>
//    - @date June 9th, 2023
//    - @copyright Copyright (c) HP Inc, 2023
//        All rights reserved. Copying or other reproduction of this program except
//        for archival purposes is prohibited without written consent of HP Inc.

import styled from 'styled-components';
import {
  colorWhite,
  fontSize11,
  fontSize5,
  space1,
  space6,
  space8
} from '@veneer/tokens/dist/tokens/tokens';

const bigMargin64 = parseInt(space8) * 2;

// Container for the whole content
export const ContentContainer = styled.div`
  max-height: 400px;
  margin-left: 20%;
`;

// Container for the logo image
export const LogoContainer = styled.div`
  filter: invert();
  margin-bottom: ${bigMargin64}px;
`;

// Container for the Texts in the Home
export const TextContainer = styled.div`
  color: ${colorWhite};
  margin-bottom: ${space6};
`;

export const marginText = {
  marginBottom: (parseInt(space8) + parseInt(space1)) * 2 + 'px'
};

// STYLING: Title text styling
export const textTitleStyle = {
  fontSize: fontSize11
};

// STYLING: Text styling
export const textStyle = {
  fontSize: fontSize5
};
